import { useCallback, useRef } from "react";
import { DropdownAtom } from "../../../../components/atoms/atom";
import { BOQ_UNITS } from "../constants/boqUnits";

/** Options for unit dropdown: { value, label } from BOQ_UNITS. */
export const UNIT_OPTIONS = BOQ_UNITS.map((u) => ({ value: u, label: u }));
export const BOQ_UNITS_SET = new Set(BOQ_UNITS);

/** Recursively collect all non-empty unitTag values from the row tree. */
export const collectAllUnitTags = (rows) => {
    const tags = [];
    rows.forEach((row) => {
        if (row.unitTag) tags.push(row.unitTag);
        if (row.children?.length) tags.push(...collectAllUnitTags(row.children));
    });
    return tags;
};

/** Creatable unit-tag dropdown that creates a new option on Enter without requiring the user
 *  to click the "Create: X" menu item. Extracted as a component so it can use useState/useRef. */
export function UnitTagDropdown({ row, unitOptionsRef, handleUnitTagChangeRef }) {
    const inputValueRef = useRef("");
    const dropdownRef = useRef(null);

    const handleKeyDown = useCallback((e) => {
        if (e.key !== "Enter") return;
        const trimmed = inputValueRef.current.trim();
        if (!trimmed) return;
        const alreadyExists = unitOptionsRef.current.some(
            (o) => String(o.value).toLowerCase() === trimmed.toLowerCase(),
        );
        if (!alreadyExists) {
            e.preventDefault();
            handleUnitTagChangeRef.current(row.original.id, trimmed);
            inputValueRef.current = "";
            dropdownRef.current?.blur();
        }
    }, [row.original.id, unitOptionsRef, handleUnitTagChangeRef]);

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <DropdownAtom
                ref={dropdownRef}
                options={unitOptionsRef.current}
                value={row.original.unitTag ?? ""}
                onChange={(e) =>
                    handleUnitTagChangeRef.current(row.original.id, e.target.value ?? "")
                }
                size="small"
                isClearable={true}
                isSearchable={true}
                isCreatable={true}
                sortOptions={false}
                className="boq-grid-unit-select"
                onInputChange={(v) => { inputValueRef.current = v; }}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
}
